module.exports = __webpack_public_path__ + "static/favicon-test-05d7f7b4966decb7f81aa2acd809043b.png";